import { useState, useEffect } from "react";
import { motion } from "framer-motion";

export const AppHeader = () => {
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 24);
    onScroll();
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const go = (href) => document.querySelector(href)?.scrollIntoView({ behavior: "smooth" });

  return (
    <motion.header
      initial={{ y: -70, opacity: 0 }}
      animate={{ y: 0, opacity: 1 }}
      transition={{ duration: 0.6, ease: [0.22, 1, 0.36, 1] }}
      className={`fixed inset-x-0 top-0 z-50 transition-all duration-500 ${
        scrolled ? "glass-strong border-b border-white/5 py-3" : "bg-transparent py-5"
      }`}
      data-testid="app-header"
    >
      <nav className="mx-auto flex max-w-7xl items-center justify-between px-6">
        <button onClick={() => go("#hero")} className="flex items-center gap-3" data-testid="header-logo">
          <img src="/assets/logo.png" alt="Taurus Technology" className="h-11 w-11 rounded-md object-cover" />
          <div className="hidden flex-col leading-none sm:flex">
            <span className="font-display text-sm font-semibold tracking-[0.25em] metallic-text">TAURUS</span>
            <span className="font-grotesk text-[9px] tracking-[0.34em] text-tt-gold">TECHNOLOGY</span>
          </div>
        </button>

        <div className="flex items-center gap-6">
          <button
            onClick={() => go("#apps")}
            className="hidden font-grotesk text-sm text-tt-silver/70 transition-colors hover:text-tt-chrome sm:inline"
            data-testid="nav-link-apps"
          >
            Apps
          </button>
          <button
            onClick={() => go("#contact")}
            className="hidden font-grotesk text-sm text-tt-silver/70 transition-colors hover:text-tt-chrome sm:inline"
            data-testid="nav-link-contact"
          >
            Support
          </button>
          <button
            onClick={() => go("#contact")}
            className="rounded-full bg-tt-gold px-5 py-2.5 font-grotesk text-sm font-medium text-tt-black transition-all duration-300 hover:bg-tt-goldsoft hover:shadow-[0_0_30px_-4px_rgba(200,162,90,0.6)]"
            data-testid="header-cta"
          >
            Contact Us
          </button>
        </div>
      </nav>
    </motion.header>
  );
};
